module.exports = __webpack_public_path__ + "img/place.b893b5ac.jpg";